import Advice from "components/common/Advice";

const SponsorshipAdvice = () => {
  return (
    <Advice
      paragraph="Somos uma empresa cidadã que, com consciência social e acolhimento, se conecta com as pessoas. Ao incentivar projetos, promovemos experiências que geram impacto positivo na sociedade e reforçamos nossos valores. Para isso, contamos com a nossa Política de Patrocínio, aprovada por acionistas e que está alinhada aos objetivos do grupo, às boas práticas recomendadas pela Controladoria-Geral da União (CGU) e às leis que regulamentam essas iniciativas. Ela define como os patrocínios serão concedidos: por meio de leis de incentivo fiscal ou recursos próprios."
    />
  );
};

export default SponsorshipAdvice;
